import React, { useReducer } from "react";
import UserReducer from "./UserReducer";
import UserContext from "./UserContext";
import {OPEN_DRAWER,CLOSE_DRAWER,SELECT_MENU} from "./types";


const UserState = (props) => {
  const initialState = {
    DrawerState:false,
    SelectedMenu:0,
    DrawerWidth:240
  };
  const [state, dispatch] = useReducer(UserReducer, initialState);

  const OpenDrawer = () => {
        dispatch({
          type: OPEN_DRAWER,
          payload: true,
        });
  };
  const CloseDrawer = () => {
    dispatch({
      type: CLOSE_DRAWER,
      payload: false,
    });
};
const SelectedMenu = (item) => {
    dispatch({
      type: SELECT_MENU,
      payload: item,
    });
};



  return (
    <UserContext.Provider
      value={{
        State: state,
        OpenDrawer,
        CloseDrawer,
        SelectedMenu,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
